import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { mailchimpSubscribeI18nEnUs } from '@luigiclaudio/ga-mailchimp-signup';
import baselineUIMessagesEnUs from '../../i18n/baselineUIMessagesEnUs';
import authMessagesEnUs from '../../i18n/authMessagesEnUs';
import siteMessagesEnUs from '../../i18n/siteMessagesEnUs.json';

const messagesEnUs = {
    ...baselineUIMessagesEnUs,
    ...mailchimpSubscribeI18nEnUs,
    ...siteMessagesEnUs,
    ...authMessagesEnUs,
};

const SiteIntlProvider = ({ children }) => {
    return (
        <IntlProvider key="en-US" locale="en-US" messages={messagesEnUs} defaultLocale="en-US">
            {children}
        </IntlProvider>
    );
};

SiteIntlProvider.propTypes = {
    children: PropTypes.node,
};

SiteIntlProvider.defaultProps = {
    children: undefined,
};

export default SiteIntlProvider;
